import React from 'react'

import {usePagination} from 'react-instantsearch'

import Pagination from './Pagination'

interface Props {
  page: number
}

export default function CustomPagination({page}: Props) {
  const {nbPages} = usePagination()

  return <Pagination page={page + 1} maxPage={nbPages} />
}
